export default __webpack_public_path__ + "static/media/Callie 9781408355268.65961530.jpg";